export const CURRENT_USER_PROFILE_LOADED = 'CURRENT_USER_PROFILE_LOADED';
export const CURRENT_USER_SUMMARIES_LOADED = 'CURRENT_USER_SUMMARIES_LOADED';
export const CURRENT_USER_CATEGORY_SUMMARY_LOADED =
    'CURRENT_USER_CATEGORY_SUMMARY_LOADED';
